// Pop-up: Google-sheet changes waiting to be applied to approved tips.
// Part of the Review page (components/Review.jsx). Split out 2026-10-14.

export default function InboxModal({ inboxBusy, inboxEntries, inboxOpen, refresh, setInboxOpen }) {
  return (
    <>
      {inboxOpen && (
        <div className="modal-backdrop" onClick={() => setInboxOpen(false)}>
          <div className="modal-card" onClick={e => e.stopPropagation()} style={{ minWidth: 720, maxWidth: 960, maxHeight: '85vh', overflowY: 'auto' }}>
            <h3 style={{ marginTop: 0 }}>📥 Sheet changes inbox</h3>
            <p className="small" style={{ color: '#666', marginTop: 0 }}>
              Rows whose content on the Google Sheet was edited after first import. Detected on every sync (Refresh / Full re-sync).
              Most recent 200 shown.
            </p>
            {inboxBusy && <div>Loading…</div>}
            {!inboxBusy && inboxEntries && inboxEntries.length === 0 && (
              <div className="card" style={{ padding: '1rem', textAlign: 'center', color: '#888' }}>
                No external sheet changes detected. ✓
              </div>
            )}
            {!inboxBusy && inboxEntries && inboxEntries.length > 0 && (
              <table className="fs-table tidy" style={{ fontSize: '0.85em' }}>
                <thead><tr><th>Detected at</th><th>Row id</th><th>Changes</th></tr></thead>
                <tbody>
                  {inboxEntries.map(a => (
                    <tr key={a.id}>
                      <td>{String(a.changed_at).slice(0,19).replace('T',' ')}</td>
                      <td><code style={{ fontSize: '0.9em' }}>{a.row_id}</code></td>
                      <td>
                        {a.changes && Object.entries(a.changes).filter(([f]) => f !== '_batchId').map(([f, v]) => (
                          <div key={f} className="small">
                            <strong>{f}:</strong> <span style={{ color: '#991b1b' }}>{String(v.from == null ? '—' : v.from)}</span>
                            {' → '}
                            <span style={{ color: '#166534' }}>{String(v.to == null ? '—' : v.to)}</span>
                          </div>
                        ))}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            <div style={{ marginTop: '1rem', textAlign: 'right' }}>
              <button className="refresh-btn" onClick={() => setInboxOpen(false)} style={{ background: '#888' }}>Close</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
